import { Crypto } from "../../../../../models/crypto.model";
export const calculateAvarageExchangeRateOfLatestTransactions = (takenRecords: Crypto[]) => {
    if(takenRecords.length === 0) return 0;

    const totalExchangeRate = takenRecords.reduce((accumlator, current) => accumlator += parseFloat(current.exchange_rate), 0);
    return parseFloat((totalExchangeRate / takenRecords.length).toFixed(2));
}